/**
 * VP-233 — normalizacja identyfikatora konta reklamowego Meta.
 *
 * Graph API zwraca `id` JUŻ z prefiksem (`act_1024756960030590`), ale w bazie
 * bywają też wpisy bez prefiksu (ręczne dopisanie konta w panelu agencji).
 * UI doklejało `act_` bezwarunkowo, więc dla kont z Meta wychodziło
 * `act_act_1024756960030590` — patrz zrzut z VP-233. Jeden helper zamiast
 * powtarzanego `act_${id}` w każdym miejscu wyświetlania.
 */

/** ID z dokładnie jednym prefiksem `act_` (odporne na wielokrotny prefiks). */
export function withActPrefix(id: string | null | undefined): string {
  const bare = bareAdAccountId(id);
  return bare ? `act_${bare}` : "";
}

/** Samo ID bez prefiksu — do linków Ads Managera (`?act=<id>`). */
export function bareAdAccountId(id: string | null | undefined): string {
  return (id ?? "").trim().replace(/^(?:act_)+/i, "");
}
